import React from 'react'
import NavigationSection from "../../../core/model2/navigation/navigation-section"
import {NavigationButtonPosition} from "../../../core/model2/navigation/@const"
import {EVENT_BUS_USER_LAST_VISIT_NOTIFICATIONS} from '../../../core/model2/user/bus'
import {ReorderItemProps} from "../../../core/gd-ui/sortable-list-4/@types"
import Navigation_ButtonHint from "../components/hint/hint-section";
import PopoverMenu from "../../../core/gd-components/popover-menu/popover-menu/popover-menu";
import Navigation_BaseButton from "./base-button";

type Props = {
    className?          : string,
    section             : NavigationSection,
    onClickCallback?    : callback
    inMorePopover       : boolean
} & ReorderItemProps

type State = {
    total    : number
    totalNew : number
}

// const debug = "Navigation_ButtonNotifications"
const debug = false

export default class Navigation_ButtonNotifications extends React.Component<Props,State> {

    public refHint                  : React.RefObject<Navigation_ButtonHint> = React.createRef<Navigation_ButtonHint>()

    constructor(props:Props) {
        super(props);

        const totals = this.calculateTotals();

        this.state = {
            total       : totals.notifications,
            totalNew    : totals.notificationsNew,
            // selected: false
        }
    }

    componentDidMount() {
        gd.session.counters.on('change add remove reset',this.onNotificationsChanged);
        gd.bus.subscribe(EVENT_BUS_USER_LAST_VISIT_NOTIFICATIONS, this, this.onNotificationsChanged)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);
        gd.session.counters.off('change add remove reset',this.onNotificationsChanged);
    }

    calculateTotals() {
        return {
            notifications       : gd.session.counters.getNotificationsCount(),
            notificationsNew    : 0
        }
    }

    onNotificationsChanged = () => {
        const totals = this.calculateTotals();

        this.setState({
            total       : totals.notifications,
            totalNew    : totals.notificationsNew
        });
    };

    showContextMenu = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()

        const options = this.props.section.positionOptions

        if (_.size(options) < 1) {
            return null
        }

        gd.layout.contextMenu.show(e,
            <PopoverMenu options        = {options}
                         hidePopover    = {() => gd.layout.contextMenu.hide()}/>,
            {
                component: this
            }
        )
    }

    onClick = async () => {
        if (this.props.onClickCallback) this.props.onClickCallback()

        this.refHint?.current?.hideHint()

        await gd.layout.navigation.openSectionV2(this.props.section)

        debug && console.log(debug, 'onClick', this.props.section, gd.session.chats)

        gd.navigation.goTo('notifications')
    }

    render() {

        const isSelected = gd.layout.navigation.state.currentSection === this.props.section

        return (
            <Navigation_BaseButton className            = {this.props.className}
                                   icon                 = "i5-notification"
                                   label                = "Notifications"
                                   style                = {this.props.style}
                                   isSelected           = {isSelected}
                                   dndPreview           = {this.props.dndPreview}
                                   dndIsDragged         = {this.props.dndIsDragged}
                                   inMorePopover        = {this.props.inMorePopover}
                                   dndIsDragInProgress  = {this.props.dndIsDragInProgress}
                                   isMouseEntered       = {this.props.isMouseEntered}
                                   onClick              = {this.onClick}
                                   showContextMenu      = {this.showContextMenu}>

                {this.state.total > 0 &&
                    <div className="btn-counter">{this.state.total}</div>
                }

                {this.props.section.position!==NavigationButtonPosition.MORE &&
                    <Navigation_ButtonHint section={this.props.section} ref={this.refHint} />
                }
            </Navigation_BaseButton>
        )
    }
}


